<template>
  <b-notification
    v-if="isActive"
    type="is-warning is-light"
    aria-close-label="Close notification"
    :closable="false"
    role="alert">
    <p>{{ $t('msg["email is not verified"]') }}</p>
    <p><a click="u-clickable" @click="sendVerificationMail">{{ $t('msg["Resend verification email"]') }}</a></p>
  </b-notification>
</template>
<script>
import site from '@/util/site'
import { Firebase } from '@/api'

export default {
  nane: 'EbEmailVerifyNotification',

  props: {
  },

  data(){
    return {
    }
  },

  computed: {
    isActive() {
      if (this.isUserAuth === false) return false
      return this.isEmailVerified === false
    },
  },

  created() {
  },

  methods: {
    async sendVerificationMail() {
      this.$store.dispatch('setLoading', true)
      try {
        await Firebase.sendEmailVerification()
        this.$store.dispatch('setLoading', false)
        this.showGlobalMessage(this.$t('msg["Sent verification email"]'), 'is-success')
      } catch (err) {
        this.debugOutput(err)
        this.$store.dispatch('setLoading', false)
        this.showGlobalMessage(this.$t('msg.sendFailed'))
      }
    }
  },
}
</script>

